import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import ALogo from '../../atoms/_atoms.logo';
import { NAVIGATION_CONFIG } from './navigation.config';
import { AIconButton, ANavigationLink, ANavigationLinkDropDown } from '../../atoms';

export default class MNavigation extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showNav: false,
		};

		this.bindHandles();
	}

	bindHandles() {
		this.handleMobileNavToggle = this.handleMobileNavToggle.bind(this);
		this.closeMobileNav = this.closeMobileNav.bind(this);
	}

	handleMobileNavToggle() {
		this.setState({ showNav: !this.state.showNav });
	}

	closeMobileNav() {
		this.setState({ showNav: false });
	}

	render() {
		let hamburger;
		const showMobileNav = this.state.showNav ? `active ${this.props.className}` : '';
		const linkConfig = !this.props.theme ? [] : NAVIGATION_CONFIG[this.props.theme];
		const links = linkConfig.map((link) => {
			switch (link.type) {
				case 'dropDown':
					return <ANavigationLinkDropDown {...link} onClick={this.closeMobileNav} />;
				default:
					return <ANavigationLink {...link} onClick={this.closeMobileNav} />;
			}
		});

		if (this.props.theme) {
			hamburger = (
				<AIconButton
					type="menu"
					className="no-color m-navigation-button"
					onClick={this.handleMobileNavToggle}
					active={this.state.showNav}
				/>
			);
		}

		return (
			<nav className="m-header-navigation">
				<Link to="/" href="/" className="navigation-logo">
					<figure>
						<ALogo />
					</figure>
				</Link>

				<ul className={`m-navigation-links ${showMobileNav}`}>
					{links}
				</ul>

				{hamburger}
			</nav>
		);
	}
}

MNavigation.propTypes = {
	theme: PropTypes.string,
	className: PropTypes.string,
};

MNavigation.defaultProps = {
	theme: undefined,
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/molecules/navigation/_molecules.navigation.js